import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Uncaught error:", error);
    console.error("[ErrorBoundary] Component stack:", info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          textAlign: "center",
          background: "#F9F8F6",
          fontFamily: "Outfit, Arial, sans-serif",
        }}
        data-testid="error-boundary-fallback"
      >
        {/* Wordmark */}
        <div
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: "2.5rem",
            letterSpacing: "0.05em",
            color: "#0B132B",
            lineHeight: 1,
          }}
        >
          EDUHUB
        </div>
        <div
          style={{
            fontSize: "0.65rem",
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            color: "#C5A059",
            marginTop: "4px",
            marginBottom: "3rem",
          }}
        >
          Academy of Excellence
        </div>

        {/* Error card */}
        <div
          style={{
            border: "1px solid #DCD7CB",
            padding: "3rem 2.5rem",
            maxWidth: "480px",
            width: "100%",
            background: "#fff",
          }}
        >
          <div
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: "2.2rem",
              color: "#0B132B",
              marginBottom: "1rem",
              lineHeight: 1.15,
            }}
          >
            Something went wrong.
          </div>

          <p
            style={{
              color: "#6B6B6B",
              lineHeight: 1.65,
              fontSize: "0.95rem",
              marginBottom: "1.75rem",
            }}
          >
            An unexpected error occurred. The error has been logged. Please
            reload the page — if the problem persists, contact support.
          </p>

          {this.state.error?.message && (
            <pre
              style={{
                fontSize: "0.68rem",
                color: "#9B9B9B",
                background: "#F0EEE8",
                border: "1px solid #DCD7CB",
                padding: "0.75rem 1rem",
                overflow: "auto",
                textAlign: "left",
                marginBottom: "1.75rem",
                maxHeight: "72px",
                lineHeight: 1.5,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {this.state.error.message}
            </pre>
          )}

          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#0B132B",
              color: "#F9F8F6",
              border: "none",
              padding: "0.8rem 2.5rem",
              cursor: "pointer",
              fontFamily: "Outfit, Arial, sans-serif",
              fontSize: "0.875rem",
              letterSpacing: "0.06em",
              textTransform: "uppercase",
            }}
            data-testid="error-boundary-reload"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
